module.exports = __webpack_public_path__ + "static/media/shared.17b23160.svg";